import { PaymentApibuild } from '@utils/api-url-builder';
const API_RESOURCE_SEGMENT_URL = 'api/Account';

export const URLS = {
  LOGIN: PaymentApibuild([API_RESOURCE_SEGMENT_URL], 'login'),
  LOGGED_USER_PROFILE: PaymentApibuild([API_RESOURCE_SEGMENT_URL], 'get-logged-user-profile'),
  IS_PARTNER_PORTAL_DIGITAL_ARCHIVE_ENABLED: PaymentApibuild([API_RESOURCE_SEGMENT_URL], 'is-partner-portal-digital-archive-enabled')
};

export const IMPERSONATED_LOGIN_SYMBOL = '->';
